<template>
  <div class="select-labels-component">
    <div v-if="labelCategories.length > 0">
      <div v-for="category in labelCategories" :key="category.id" class="label-group">
        <h3>{{ category.name }}</h3>
        <div v-if="category.tags && category.tags.length > 0">
          <van-tag v-for="tag in category.tags" :key="tag.id" size="large"
            :class="[isTagSelected(category.id, tag) ? 'tag-selected' : 'tag-unselected']"
            @click="toggleTag(category.id, tag)">
            {{ tag.name }}
          </van-tag>
        </div>
      </div>
    </div>
    <van-empty v-else description="暂无标签数据" image="search" :image-size="80" />
  </div>
</template>

<script>
import { Toast, Dialog, Empty } from 'vant';
export default {
  components: {
    VanEmpty: Empty
  },
  name: 'SelectLabels',
  props: {
    labelCategories: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      selectedTags: {}
    };
  },
  created() {
    this.initSelectedTags();
  },
  methods: {
    // 初始化选中标签对象
    initSelectedTags() {
      this.labelCategories.forEach(group => {
        this.selectedTags[group.id] = [];
      });
    },
    
    // 判断标签是否被选中
    isTagSelected(categoryId, tag) {
      return this.selectedTags[categoryId] && this.selectedTags[categoryId].includes(tag.id);
    },
    
    // 切换标签选中状态
    toggleTag(categoryId, tag) {
      // 创建一个新的selectedTags对象，确保触发页面刷新
      const newSelectedTags = { ...this.selectedTags };

      // 切换标签选中状态时，检查是否是新增选中（如果当前未选中）
      const isCurrentlySelected = this.isTagSelected(categoryId, tag);

      // 确保该分类的选中数组存在
      if (!newSelectedTags[categoryId]) {
        newSelectedTags[categoryId] = [];
      } else {
        // 创建新的数组副本以避免直接修改原数组
        newSelectedTags[categoryId] = [...newSelectedTags[categoryId]];
      }

      // 切换标签选中状态
      const index = newSelectedTags[categoryId].indexOf(tag.id);
      if (index > -1) {
        // 删除元素
        newSelectedTags[categoryId].splice(index, 1);
      } else {
        // 添加元素
        newSelectedTags[categoryId].push(tag.id);
      }

      // 完全替换整个selectedTags对象，强制Vue更新视图
      this.selectedTags = newSelectedTags;

      // 收集所有选中的标签ID并通知父组件
      const allSelectedTags = [];
      Object.values(this.selectedTags).forEach(tagIds => {
        allSelectedTags.push(...tagIds);
      });
      
      // 触发自定义事件，将选中的标签ID传递给父组件
      this.$emit('tags-selected', allSelectedTags);
    },
    
    // 获取所有选中的标签ID
    getAllSelectedTags() {
      const allSelectedTags = [];
      Object.values(this.selectedTags).forEach(tagIds => {
        allSelectedTags.push(...tagIds);
      });
      return allSelectedTags;
    }
  }
};
</script>

<style scoped lang="less">
.select-labels-component {
  padding: 0;
}

.label-group {
  margin-bottom: var(--base-px-20);
}

.label-group h3 {
  color: #333;
  font-size: var(--base-px-16);
  margin-bottom: var(--base-px-10);
}

/* 未选中标签样式 */
.van-tag.tag-unselected {
  background-color: #f5f5f5;
  color: #666;
  border: var(--base-px-1) solid #e5e5e5;
  margin-right: var(--base-px-8);
  margin-bottom: var(--base-px-8);
}

/* 选中标签样式 */
.van-tag.tag-selected {
  background-color: #006eff;
  color: #fff;
  border: var(--base-px-1) solid #006eff;
  margin-right: var(--base-px-8);
  margin-bottom: var(--base-px-8);
}

</style>